import _defineProperty from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent, createRef } from 'react';
import { MobileCancelMajor } from '@shopify/polaris-icons';
import { durationSlow } from '@shopify/polaris-tokens';
import { CSSTransition } from 'react-transition-group';
import { classNames } from '../../utilities/css.js';
import { layer, dataPolarisTopBar } from '../shared.js';
import { setRootProperty } from '../../utilities/set-root-property.js';
import styles from './Frame.scss.js';
import { Loading } from './components/Loading/Loading.js';
import { CSSAnimation } from './components/CSSAnimation/CSSAnimation.js';
import { ContextualSaveBar } from './components/ContextualSaveBar/ContextualSaveBar.js';
import { FrameContext } from '../../utilities/frame/context.js';
import { ToastManager } from './components/ToastManager/ToastManager.js';
import { useI18n } from '../../utilities/i18n/hooks.js';
import { useMediaQuery } from '../../utilities/media-query/hooks.js';
import { TrapFocus } from '../TrapFocus/TrapFocus.js';
import { Icon } from '../Icon/Icon.js';
import { Backdrop } from '../Backdrop/Backdrop.js';
import { EventListener } from '../EventListener/EventListener.js';
var GLOBAL_RIBBON_CUSTOM_PROPERTY = '--global-ribbon-height';
var APP_FRAME_MAIN = 'AppFrameMain';
var APP_FRAME_NAV = 'AppFrameNav';
var APP_FRAME_TOP_BAR = 'AppFrameTopBar';
var APP_FRAME_LOADING_BAR = 'AppFrameLoadingBar';

var FrameInner = /*#__PURE__*/function (_PureComponent) {
  _inherits(FrameInner, _PureComponent);

  var _super = _createSuper(FrameInner);

  function FrameInner() {
    var _this;

    _classCallCheck(this, FrameInner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      skipFocused: false,
      globalRibbonHeight: 0,
      loadingStack: 0,
      toastMessages: [],
      showContextualSaveBar: false
    };
    _this.contextualSaveBar = null;
    _this.globalRibbonContainer = null;
    _this.navigationNode = /*#__PURE__*/createRef();

    _this.setGlobalRibbonHeight = function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          globalRibbonContainer = _assertThisInitialize.globalRibbonContainer;

      if (globalRibbonContainer) {
        _this.setState({
          globalRibbonHeight: globalRibbonContainer.offsetHeight
        }, _this.setGlobalRibbonRootProperty);
      }
    };

    _this.setGlobalRibbonRootProperty = function () {
      var globalRibbonHeight = _this.state.globalRibbonHeight;
      setRootProperty(GLOBAL_RIBBON_CUSTOM_PROPERTY, "".concat(globalRibbonHeight, "px"), null);
    };

    _this.showToast = function (toast) {
      _this.setState(function (_ref) {
        var toastMessages = _ref.toastMessages;
        var hasToastById = toastMessages.find(function (_ref2) {
          var id = _ref2.id;
          return id === toast.id;
        }) != null;
        return {
          toastMessages: hasToastById ? toastMessages : [].concat(_toConsumableArray(toastMessages), [toast])
        };
      });
    };

    _this.hideToast = function (_ref3) {
      var id = _ref3.id;

      _this.setState(function (_ref4) {
        var toastMessages = _ref4.toastMessages;
        return {
          toastMessages: toastMessages.filter(function (_ref5) {
            var toastId = _ref5.id;
            return id !== toastId;
          })
        };
      });
    };

    _this.setContextualSaveBar = function (props) {
      var showContextualSaveBar = _this.state.showContextualSaveBar;
      _this.contextualSaveBar = _objectSpread({}, props);

      if (showContextualSaveBar === true) {
        _this.forceUpdate();
      } else {
        _this.setState({
          showContextualSaveBar: true
        });
      }
    };

    _this.removeContextualSaveBar = function () {
      _this.contextualSaveBar = null;

      _this.setState({
        showContextualSaveBar: false
      });
    };

    _this.startLoading = function () {
      _this.setState(function (_ref6) {
        var loadingStack = _ref6.loadingStack;
        return {
          loadingStack: loadingStack + 1
        };
      });
    };

    _this.stopLoading = function () {
      _this.setState(function (_ref7) {
        var loadingStack = _ref7.loadingStack;
        return {
          loadingStack: Math.max(0, loadingStack - 1)
        };
      });
    };

    _this.handleResize = function () {
      if (_this.props.globalRibbon) {
        _this.setGlobalRibbonHeight();
      }
    };

    _this.handleFocus = function () {
      _this.setState({
        skipFocused: true
      });
    };

    _this.handleBlur = function () {
      _this.setState({
        skipFocused: false
      });
    };

    _this.handleClick = function (event) {
      var skipToContentTarget = _this.props.skipToContentTarget;

      if (skipToContentTarget && skipToContentTarget.current) {
        skipToContentTarget.current.focus();
        event === null || event === void 0 ? void 0 : event.preventDefault();
      }
    };

    _this.handleNavigationDismiss = function () {
      var onNavigationDismiss = _this.props.onNavigationDismiss;

      if (onNavigationDismiss != null) {
        onNavigationDismiss();
      }
    };

    _this.setGlobalRibbonContainer = function (node) {
      _this.globalRibbonContainer = node;
    };

    _this.handleNavKeydown = function (event) {
      var key = event.key;
      var _this$props = _this.props,
          isNavigationCollapsed = _this$props.mediaQuery.isNavigationCollapsed,
          showMobileNavigation = _this$props.showMobileNavigation;
      var mobileNavShowing = isNavigationCollapsed && showMobileNavigation;

      if (mobileNavShowing && key === 'Escape') {
        _this.handleNavigationDismiss();
      }
    };

    return _this;
  }

  _createClass(FrameInner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleResize();

      if (this.props.globalRibbon) {
        return;
      }

      this.setGlobalRibbonRootProperty();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.globalRibbon !== prevProps.globalRibbon) {
        this.setGlobalRibbonHeight();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          skipFocused = _this$state.skipFocused,
          loadingStack = _this$state.loadingStack,
          toastMessages = _this$state.toastMessages,
          showContextualSaveBar = _this$state.showContextualSaveBar;
      var _this$props2 = this.props,
          children = _this$props2.children,
          navigation = _this$props2.navigation,
          topBar = _this$props2.topBar,
          globalRibbon = _this$props2.globalRibbon,
          _this$props2$showMobi = _this$props2.showMobileNavigation,
          showMobileNavigation = _this$props2$showMobi === void 0 ? false : _this$props2$showMobi,
          skipToContentTarget = _this$props2.skipToContentTarget,
          i18n = _this$props2.i18n,
          isNavigationCollapsed = _this$props2.mediaQuery.isNavigationCollapsed;
      var navClassName = classNames(styles.Navigation, showMobileNavigation && styles['Navigation-visible']);
      var mobileNavHidden = isNavigationCollapsed && !showMobileNavigation;
      var mobileNavShowing = isNavigationCollapsed && showMobileNavigation;
      var tabIndex = mobileNavShowing ? 0 : -1;

      var mobileNavAttributes = _objectSpread({}, mobileNavShowing && {
        'aria-modal': true,
        role: 'dialog'
      });

      var navigationMarkup = navigation ? /*#__PURE__*/React.createElement(TrapFocus, {
        trapping: mobileNavShowing
      }, /*#__PURE__*/React.createElement(CSSTransition, {
        nodeRef: this.navigationNode,
        appear: isNavigationCollapsed,
        exit: isNavigationCollapsed,
        in: showMobileNavigation,
        timeout: durationSlow,
        classNames: navTransitionClasses
      }, /*#__PURE__*/React.createElement("div", Object.assign({
        key: "NavContent"
      }, mobileNavAttributes, {
        "aria-label": i18n.translate('Polaris.Frame.navigationLabel'),
        ref: this.navigationNode,
        className: navClassName,
        onKeyDown: this.handleNavKeydown,
        id: APP_FRAME_NAV,
        hidden: mobileNavHidden
      }), navigation, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: styles.NavigationDismiss,
        onClick: this.handleNavigationDismiss,
        "aria-hidden": mobileNavHidden || !isNavigationCollapsed && !showMobileNavigation,
        "aria-label": i18n.translate('Polaris.Frame.Navigation.closeMobileNavigationLabel'),
        tabIndex: tabIndex
      }, /*#__PURE__*/React.createElement(Icon, {
        source: MobileCancelMajor
      }))))) : null;
      var loadingMarkup = loadingStack > 0 ? /*#__PURE__*/React.createElement("div", {
        className: styles.LoadingBar,
        id: APP_FRAME_LOADING_BAR
      }, /*#__PURE__*/React.createElement(Loading, null)) : null;
      var contextualSaveBarMarkup = /*#__PURE__*/React.createElement(CSSAnimation, {
        in: showContextualSaveBar,
        className: styles.ContextualSaveBar,
        type: "fade"
      }, /*#__PURE__*/React.createElement(ContextualSaveBar, this.contextualSaveBar));
      var topBarMarkup = topBar ? /*#__PURE__*/React.createElement("div", Object.assign({
        className: styles.TopBar
      }, layer.props, dataPolarisTopBar.props, {
        id: APP_FRAME_TOP_BAR
      }), topBar) : null;
      var globalRibbonMarkup = globalRibbon ? /*#__PURE__*/React.createElement("div", {
        className: styles.GlobalRibbonContainer,
        ref: this.setGlobalRibbonContainer
      }, globalRibbon) : null;
      var skipClassName = classNames(styles.Skip, skipFocused && styles.focused);
      var skipTarget = skipToContentTarget !== null && skipToContentTarget !== void 0 && skipToContentTarget.current ? skipToContentTarget.current.id : APP_FRAME_MAIN;
      var skipMarkup = /*#__PURE__*/React.createElement("div", {
        className: skipClassName
      }, /*#__PURE__*/React.createElement("a", {
        href: "#".concat(skipTarget),
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleClick
      }, i18n.translate('Polaris.Frame.skipToContent')));
      var navigationAttributes = navigation ? {
        'data-has-navigation': true
      } : {};
      var frameClassName = classNames(styles.Frame, navigation && styles.hasNav, topBar && styles.hasTopBar);
      var navigationOverlayMarkup = showMobileNavigation && isNavigationCollapsed ? /*#__PURE__*/React.createElement(Backdrop, {
        belowNavigation: true,
        onClick: this.handleNavigationDismiss,
        onTouchStart: this.handleNavigationDismiss
      }) : null; // This is probably a legit error but I don't have the time to refactor this
      // eslint-disable-next-line react/jsx-no-constructed-context-values

      var context = {
        showToast: this.showToast,
        hideToast: this.hideToast,
        startLoading: this.startLoading,
        stopLoading: this.stopLoading,
        setContextualSaveBar: this.setContextualSaveBar,
        removeContextualSaveBar: this.removeContextualSaveBar
      };
      return /*#__PURE__*/React.createElement(FrameContext.Provider, {
        value: context
      }, /*#__PURE__*/React.createElement("div", Object.assign({
        className: frameClassName
      }, layer.props, navigationAttributes), skipMarkup, topBarMarkup, navigationMarkup, contextualSaveBarMarkup, loadingMarkup, navigationOverlayMarkup, /*#__PURE__*/React.createElement("main", {
        className: styles.Main,
        id: APP_FRAME_MAIN,
        "data-has-global-ribbon": Boolean(globalRibbon)
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.Content
      }, children)), /*#__PURE__*/React.createElement(ToastManager, {
        toastMessages: toastMessages
      }), globalRibbonMarkup, /*#__PURE__*/React.createElement(EventListener, {
        event: "resize",
        handler: this.handleResize
      })));
    }
  }]);

  return FrameInner;
}(PureComponent);

var navTransitionClasses = {
  enter: classNames(styles['Navigation-enter']),
  enterActive: classNames(styles['Navigation-enterActive']),
  enterDone: classNames(styles['Navigation-enterActive']),
  exit: classNames(styles['Navigation-exit']),
  exitActive: classNames(styles['Navigation-exitActive'])
};

function Frame(props) {
  var i18n = useI18n();
  var mediaQuery = useMediaQuery();
  return /*#__PURE__*/React.createElement(FrameInner, Object.assign({}, props, {
    i18n: i18n,
    mediaQuery: mediaQuery
  }));
}

export { Frame };